import React from 'react';

// Brand logo — official Guardian Artificial Lawns mark (V4).
// Transparent brushed-chrome wordmark + green grass row. Reads cleanly
// on dark forest navbar/footer and on cream sections too — no shadow.
//
// Optional `shimmer` prop adds a one-time diagonal highlight sweep that
// only paints across the actual chrome letter shapes (via mask-image),
// giving the mark a premium "metallic flash" on page load.
export default function Logo({ className = '', size = 'md', shimmer = false, glow = false }) {
  const heights = {
    sm: 'h-11 md:h-12',
    md: 'h-16 md:h-20',
    lg: 'h-14 md:h-16',
    xl: 'h-36 md:h-44',
  };
  const h = heights[size] || heights.md;

  // `glow` adds a soft cream drop-shadow halo behind the artwork so the
  // sub-line "ARTIFICIAL LAWNS" (which is a darker brushed grey) reads
  // clearly when the mark sits on the green footer canvas.
  const glowFilter = glow
    ? 'drop-shadow(0 0 6px rgba(231,233,228,0.45)) drop-shadow(0 0 18px rgba(231,233,228,0.25))'
    : 'none';

  const img = (
    <img
      src="/guardian-logo.png"
      alt="Guardian Artificial Lawns"
      className={`${h} w-auto object-contain select-none ${className}`}
      style={{ filter: glowFilter }}
      loading="eager"
      decoding="async"
    />
  );

  if (!shimmer) return img;

  return (
    <span className={`logo-shimmer-host relative inline-block ${h}`} aria-hidden={false}>
      {img}
      <span
        aria-hidden="true"
        className="logo-shimmer pointer-events-none absolute inset-0"
        style={{
          WebkitMaskImage: 'url(/guardian-logo.png)',
          maskImage: 'url(/guardian-logo.png)',
        }}
      />
    </span>
  );
}
